import { ChartContainer } from './ChartContainer';
import { Eye, UserPlus, MousePointer } from 'lucide-react';
import { ScrollArea } from '../ui/scroll-area';

const activityIcons = {
  visit: Eye,
  registration: UserPlus,
  click: MousePointer
};

const activityColors = {
  visit: 'text-blue-400 bg-blue-400/10',
  registration: 'text-emerald-400 bg-emerald-400/10',
  click: 'text-primary bg-primary/10'
};

export const RecentActivity = ({ data }) => {
  return (
    <ChartContainer 
      title="Live Activity" 
      subtitle="Real-time visitor actions"
    >
      <ScrollArea className="h-[280px] pr-4" data-testid="recent-activity">
        <div className="space-y-3">
          {data.map((activity) => {
            const Icon = activityIcons[activity.type];
            const colorClass = activityColors[activity.type];
            
            return (
              <div 
                key={activity.id}
                className="flex items-start gap-3 p-3 rounded-lg bg-secondary/30 hover:bg-secondary/50 transition-colors"
              >
                <div className={`p-2 rounded-lg ${colorClass}`}>
                  <Icon className="w-4 h-4" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between gap-2">
                    <span className="text-sm font-manrope font-medium text-foreground truncate">
                      {activity.type === 'registration' ? 'New Registration' : `Viewed ${activity.page}`}
                    </span>
                    <span className="text-xs text-muted-foreground whitespace-nowrap">
                      {activity.time}
                    </span>
                  </div>
                  <p className="text-xs text-muted-foreground mt-0.5">
                    {activity.location}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </ScrollArea>
    </ChartContainer>
  );
};
